import React, { useState, useEffect } from "react";
import styles from "./driverBooking.module.css";
import velocityLogo from "../../images/logo2.png";
import alSalamLogo from "../../images/al_salaam_logo.webp";

const DriverBooking = () => {
  const [driverId, setDriverId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [tripType, setTripType] = useState("single");
  const [pickupLocation, setPickupLocation] = useState("");
  const [destination, setDestination] = useState("");
  const [fare, setFare] = useState("");
  const [vehicleId, setVehicleId] = useState("");
  const [companyName, setCompanyName] = useState("Velocity Limousine LLC");
  const [logoSrc, setLogoSrc] = useState(velocityLogo);
  const [bookingId, setBookingId] = useState("");
  const [bookingDateTime, setBookingDateTime] = useState("");
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const driverIdParam = urlParams.get("driver_id");
    const vehicleIdParam = urlParams.get("vehicle_id");

    if (driverIdParam) {
      setDriverId(driverIdParam);
    }
    if (vehicleIdParam) {
      setVehicleId(vehicleIdParam);
      updateCompanyName(vehicleIdParam);
    }
  }, []);

  const updateCompanyName = (vehicleId) => {
    const alSalaamVehicleIds = [
      "46245",
      "46250",
      "79844",
      "56419",
      "18041",
      "18997",
      "25949",
    ];

    if (alSalaamVehicleIds.includes(vehicleId)) {
      setCompanyName("Al Salaam Limousine LLC");
      setLogoSrc(alSalamLogo);
    } else {
      setCompanyName("Velocity Limousine LLC");
      setLogoSrc(velocityLogo);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const currentDateTime = getCurrentDateTime();
    const formattedDateTime = formatDateTime(currentDateTime);
    const newBookingId = generateBookingID();

    try {
      const response = await fetch(
        "https://m1yc291zs5.execute-api.ap-south-1.amazonaws.com/bookingFormProcessor",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            driver_name: driverId,
            customer_name: customerName,
            trip_type: tripType === "dayhire" ? "Day Hire" : "Single Trip",
            pickup_location: pickupLocation,
            destination: destination || "N/A",
            fare: fare,
            pickup_date: formattedDateTime.split(" ")[0],
            pickup_time: formattedDateTime.split(" ")[1],
            booking_id: newBookingId,
            vehicle_id: vehicleId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setBookingId(newBookingId);
      setBookingDateTime(formattedDateTime);
      setConfirmationVisible(true);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      alert("There was an issue submitting the form. Please try again.");
      setLoading(false);
    }
  };

  const handleTripTypeChange = (event) => {
    setTripType(event.target.value);
  };

  const generateBookingID = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "VEL-";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const getCurrentDateTime = () => {
    const offset = 4 * 60 * 60 * 1000;
    let now = new Date();
    now = new Date(now.getTime() + offset);
    return now.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatDateTime = (currentDateTime) => {
    const [datePart, timePart] = currentDateTime.split(" ");
    const dateTime = new Date(`${datePart}T${timePart}`);
    const year = dateTime.getFullYear();
    const month = dateTime.getMonth() + 1;
    const day = dateTime.getDate();
    let hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const seconds = dateTime.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");
    const formattedDate = `${month}/${day}/${year}`;
    const formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className={styles.containerParent}>
      {/* <div>hi</div> */}
      <div className={styles.container}>
        <img src={logoSrc} alt="Company Logo" className={styles.logo} />
        <div className={styles.companyName}>{companyName}</div>
        {loading && <div className={styles.loader}></div>}

        {!confirmationVisible ? (
          <div id="bookingFormContainer">
            <h2>Create Booking</h2>
            <form id="bookingForm" onSubmit={handleSubmit}>
              <input
                type="text"
                id="driver_id"
                placeholder="Driver Name"
                required
                value={driverId}
                onChange={(e) => setDriverId(e.target.value)}
                className={styles.driverBookingInput} // Apply style
              />
              <input
                type="text"
                id="customer_name"
                placeholder="Customer Name"
                required
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                className={styles.driverBookingInput} // Apply style
              />
              <select
                id="trip_type"
                value={tripType}
                onChange={handleTripTypeChange}
                className={styles.driverBookingSelect}
              >
                <option value="single">Single Trip</option>
                <option value="dayhire">Day Hire</option>
              </select>
              <input
                type="text"
                id="pickup_location"
                placeholder="Pickup Location"
                required
                value={pickupLocation}
                onChange={(e) => setPickupLocation(e.target.value)}
                className={styles.driverBookingInput} // Apply style
              />
              <input
                type="text"
                id="destination"
                placeholder="Destination"
                style={{ display: tripType === "dayhire" ? "none" : "block" }}
                value={destination}
                onChange={(e) => setDestination(e.target.value)}
                className={styles.driverBookingInput} // Apply style
              />
              <input
                type="text"
                id="fare"
                placeholder="Fare"
                required
                value={fare}
                onChange={(e) => setFare(e.target.value)}
                className={styles.driverBookingInput} // Apply style
              />
              <input
                type="hidden"
                id="vehicle_id"
                value={vehicleId}
                onChange={(e) => setVehicleId(e.target.value)}
              />
              <input
                type="submit"
                value="Submit"
                disabled={loading}
                className={styles.submitButton}
              />
            </form>
          </div>
        ) : (
          <div className={styles.driverBookingConfirmation}>
            <h3>Booking Confirmation</h3>
            <p>
              <strong>{companyName}</strong>
            </p>
            <p>
              <strong>Booking ID:</strong> {bookingId}
            </p>
            <p>
              <strong>Booking Date & Time:</strong> {bookingDateTime}
            </p>
            <p>
              <strong>Driver Name:</strong> {driverId}
            </p>
            <p>
              <strong>Vehicle:</strong> {vehicleId}{" "}
            </p>
            <p>
              <strong>Customer Name:</strong> {customerName}
            </p>
            <p>
              <strong>Trip Type:</strong>{" "}
              {tripType === "dayhire" ? "Day Hire" : "Single Trip"}
            </p>
            <p>
              <strong>Pickup Location:</strong> {pickupLocation}
            </p>
            <p>
              <strong>Destination:</strong> {destination || "N/A"}
            </p>
            <p>
              <strong>Fare:</strong> {fare} AED
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DriverBooking;
